import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemEventsAddRoute: InvariantJiraRoute = {
	name: 'global-settings-system-events-add',
	path: '/secure/admin/AddEventType.jspa',
};
